module.exports = __webpack_public_path__ + "img/junior-designer.5c9e2f06.svg";